/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Katalog_Desi_Page_SubtitleInputs */

const tr_katalog_desi_page_subtitle = /** @type {(inputs: Katalog_Desi_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kargo desisi nedir, nasıl hesaplanır ve 1 desi kaç kilograma denk gelir?`)
};

const en_katalog_desi_page_subtitle = /** @type {(inputs: Katalog_Desi_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is cargo desi, how is it calculated and how many kilograms is 1 desi?`)
};

const de_katalog_desi_page_subtitle = /** @type {(inputs: Katalog_Desi_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist Fracht-Desi, wie wird es berechnet und wie viel Kilogramm ist 1 Desi?`)
};

const ru_katalog_desi_page_subtitle = /** @type {(inputs: Katalog_Desi_Page_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что такое деси, как его рассчитать и скольким килограммам равен 1 деси?`)
};

/**
* | output |
* | --- |
* | "What is cargo desi, how is it calculated and how many kilograms is 1 desi?" |
*
* @param {Katalog_Desi_Page_SubtitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const katalog_desi_page_subtitle = /** @type {((inputs?: Katalog_Desi_Page_SubtitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Katalog_Desi_Page_SubtitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_katalog_desi_page_subtitle(inputs)
	if (locale === "de") return de_katalog_desi_page_subtitle(inputs)
	if (locale === "ru") return ru_katalog_desi_page_subtitle(inputs)
	return tr_katalog_desi_page_subtitle(inputs)
});